export default "/static/images/build_middle_2.png?1e5e6d0ea64ea246af8aeedfc0d7afab";